import { render, staticRenderFns } from "./BoxContainer.vue?vue&type=template&id=83de15fc&scoped=true&"
import script from "./BoxContainer.vue?vue&type=script&lang=js&"
export * from "./BoxContainer.vue?vue&type=script&lang=js&"
import style0 from "./BoxContainer.vue?vue&type=style&index=0&id=83de15fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83de15fc",
  null
  
)

export default component.exports